/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type ImportTasksMutationVariables = Types.Exact<{
  object: Types.ImportTasksInput;
}>;

export type ImportTasksMutation = { __typename?: 'mutation_root'; import_tasks: string };

export const ImportTasksDocument = `
    mutation ImportTasks($object: ImportTasksInput!) {
  import_tasks(object: $object)
}
    ` as string & TypedDocumentNode<ImportTasksMutation, ImportTasksMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    ImportTasks: build.mutation<ImportTasksMutation, ImportTasksMutationVariables>({
      query: (variables) => ({ document: ImportTasksDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useImportTasksMutation } = injectedRtkApi;
